export const drpOptions = [
  { value: 250000, label: "$250,000" },
  { value: 300000, label: "$300,000" },
  { value: 500000, label: "$500,000" },
  { value: 1000000, label: "$1,000,000" },
];
